import { render, staticRenderFns } from "./add_note.vue?vue&type=template&id=486cefd4&scoped=true"
import script from "./add_note.vue?vue&type=script&lang=js"
export * from "./add_note.vue?vue&type=script&lang=js"
import style0 from "./add_note.vue?vue&type=style&index=0&id=486cefd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486cefd4",
  null
  
)

export default component.exports